import React from 'react'
import { string, node } from 'prop-types'
import { white, secondaryColor, primaryColor } from 'styles/colors'
import styled from 'styled-components'
import * as spacing from 'styles/spacing'

const getFill = props => {
  if (props.color === 'white') return white
  if (props.color === 'brand') return primaryColor
  if (props.color === 'accent') return secondaryColor
  return 'currentColor'
}

const getSpacing = props => {
  if (props.size === 'small') return spacing.medium
  if (props.size === 'medium') return spacing.xLarge
  if (props.size === 'large') return spacing.xxLarge
  if (props.size === 'xLarge') return spacing.xxxLarge
  return spacing.large
}

const Container = styled.div`
  position: relative;
  display: inline-block;
  fill: ${getFill};
  width: ${getSpacing};
  height: ${getSpacing};
  vertical-align: top;

  > svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const Icon = ({ icon, size, color }) => (
  <Container size={size} color={color}>
    {icon}
  </Container>
)

Icon.propTypes = {
  icon: node.isRequired,
  size: string,
  color: string
}

export default Icon
